<div class="modal-content cadastro-cartao">
  <div class="modal-body">
    <div class="row">
      <div class="col-lg-4 col-12 border-right cadastro-cartao__painel">
        <h3>{{contrato?.empresa?.nome || contrato?.empresa?.nomeFantasia || 'Assinatura'}}</h3>
        <h4>Cadastre o cartão da assinatura</h4>

        <div class="cadastro-cartao__plano" *ngIf="contrato?.id">
          <label>Plano:</label>
          <span class="font-16 ml-2 text-success"><b>{{contrato?.plano?.nome || 'Plano contratado'}}</b></span>
          <span *ngIf="contrato?.limiteContatos"> | {{contrato.limiteContatos | number}} contatos ativos.</span>
        </div>

        <div class="cadastro-cartao__cobranca" *ngIf="contrato?.dataProximoVencimento || contrato?.assinatura?.dataVencimento">
          <label>Próxima cobrança</label>
          <strong>{{(contrato?.dataProximoVencimento || contrato?.assinatura?.dataVencimento) | date:'dd/MM/yyyy'}}</strong>
        </div>

        <div class="alert alert-info mt-2">
          Este cartão será usado nas próximas cobranças. Nenhuma cobrança será realizada agora.
        </div>

        <div *ngIf="!contrato?.id">
          <div class="alert alert-info mt-2" role="alert">
            <i class="mdi mdi-check-all mr-2"></i> Aguardando contrato ser carregado.
          </div>
        </div>

        <div class="alert alert-danger alert-dismissible fade show mt-2" role="alert" *ngIf="erro">
          <i class="mdi mdi-alert-circle-outline mr-2"></i> {{erro}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" (click)="fecheMensagemErro()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <span [hidden]="salvo">
          <h5 class="text-center mt-2">Cartão de Crédito</h5>

          <cad-cartaocredito #cccompoment
                             textoBotao="Salvar cartão"
                             (onCriou)="salveCartao($event)"
                             *ngIf="contrato?.id">
          </cad-cartaocredito>
        </span>

        <span [hidden]="!salvo">
          <h4 class="text-success text-center mt-3">Cartão salvo com sucesso!</h4>
        </span>
      </div>

      <div class="col-lg-8 col-0 cadastro-cartao__quadro">
        <div class="cadastro-cartao__imagem">
          <div class="cadastro-cartao__promo-info">
            <h3>Atualize seu cartão com segurança.</h3>
            <p>O novo cartão fica vinculado à assinatura para as próximas cobranças recorrentes.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
